import { createSelector } from '@reduxjs/toolkit'

import { makeFetchSelectors, makeTypedFetchSelectors } from 'app/redux-fetch'
import type { RootState } from 'app/store'
import type { PaymentMethodType } from './types'

import {
  DETACH_PAYMENT_METHODS_REDUCER_NAME,
  PAYMENT_METHODS_LIST_REDUCER_NAME,
  PAYMENT_METHODS_REDUCER_NAME,
  PM_DEFAULT_REQUEST_REDUCER_NAME,
  SELECTED_PAYMENT_METHOD_REDUCER_NAME,
} from './consts'

export const paymentMethodsListSelector = makeTypedFetchSelectors<
  PaymentMethodType[]
>(PAYMENT_METHODS_REDUCER_NAME, PAYMENT_METHODS_LIST_REDUCER_NAME)

export const hasNoPaymentMethodsSelector = createSelector(
  paymentMethodsListSelector.data,
  paymentMethodsListSelector.isFetching,
  (paymentMethods, isFetching) => {
    return !isFetching && !!paymentMethods && !paymentMethods.length
  }
)

export const selectedPaymentMethodIdSelector = createSelector(
  (store: RootState) =>
    store[PAYMENT_METHODS_REDUCER_NAME][SELECTED_PAYMENT_METHOD_REDUCER_NAME],
  (selectedPaymentMethod) => selectedPaymentMethod.id
)

export const detachPaymentMethodSelectors = makeFetchSelectors(
  PAYMENT_METHODS_REDUCER_NAME,
  DETACH_PAYMENT_METHODS_REDUCER_NAME
)

export const defaultPaymentMethodRequestSelectors = makeFetchSelectors(
  PAYMENT_METHODS_REDUCER_NAME,
  PM_DEFAULT_REQUEST_REDUCER_NAME
)
